/*
 * @Author: Junchi Zhao
 * @LastEditors: Please set LastEditors
 * @Description:
 */
//获取当前客户端地址
function getClientUrl() {
  let url = '';
  //多pathname且包含index.html
  if (window.location.pathname && window.location.pathname.indexOf('.') > -1) {
    url =
      window.location.origin +
      window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/'));
  } else if (window.location.pathname && window.location.pathname !== '/') {
    url = window.location.origin + window.location.pathname;
  } else {
    url = window.location.origin;
  }
  return url;
}
export const projectName = '金惠OA|数智办公';
const currentClientURL = getClientUrl();
export const baseURL = process.env.VITE_BASE_URL || currentClientURL; //接口地址
export const uploadURL = process.env.VITE_UPLOAD_URL || currentClientURL; //上传地址
export const logURL = process.env.VITE_LOG_URL || currentClientURL; //日志地址
export const wsURL = process.env.VITE_WS_URL || currentClientURL; //预览地址
export const previewURL = process.env.VITE_PREVIEW_URL || currentClientURL; //预览服务地址
export const isWaterMark = true;
export const pwdEncryptType = 'SM3';
export const transferEncryptType = 'SM4';
export const isMock =
  process.env.NODE_ENV === 'development' && process.env.VITE_MOCK === 'TRUE' ? true : false;
export const startMode = process.env.VITE_START_MODE;
export const isOpenWs = false; //是否开启websocket
export const getFileCompressParams = false; //是否开启文件压缩参数
export const getUserIndiviality = true; //是否开启用户个性化配置
export const getHomePageSetting = true; //是否开启首页配置
export const openChildAccount = true; //开启子账号功能
// 钉钉登录配置
export const dingTalkConfig = {
  corpId: process.env.VITE_DINGTALK_CORP_ID, // 钉钉企业ID
  clientId: process.env.VITE_DINGTALK_CLIENT_ID, // 钉钉应用ID
  enabled: process.env.VITE_DINGTALK_ENABLED // 是否启用钉钉登录
};
export function getGlobalConfig() {
  return {
    baseURL: baseURL,
    uploadURL: uploadURL,
    logURL: logURL,
    wsURL: wsURL,
    isOpenWs: isOpenWs,
    previewURL: previewURL,
    isWaterMark: isWaterMark,
    pwdEncryptType: pwdEncryptType,
    transferEncryptType: transferEncryptType,
    isMock: isMock,
    openChildAccount: openChildAccount,
    startMode: startMode,
    getFileCompressParams: getFileCompressParams,
    getUserIndiviality: getUserIndiviality,
    getHomePageSetting: getHomePageSetting
  };
}
